// The sheets the user changes in Excel, handed to the index once they pause (product owner, 2026-09-30: 3 s;
// 2026-10-06: 1.5 s — the catch-up is the wait before the next message, and a change made while it reads a sheet
// drops that run for one covering both, `WorkbookIndexer.markChanged`). Twenty values typed in a row are one
// re-index, and each changed sheet is read once however often it changed.
// Host-agnostic: the events come from `ExcelToolExecutor.watchSheetChanges`, the re-index is the caller's.

/** Quiet time after the last change before the re-index starts. */
export const CHANGE_QUIET_MS = 1500;

export class ChangeBatcher {
  private sheets = new Set<string>();
  private timer: ReturnType<typeof setTimeout> | null = null;

  /** `flush` receives the sheets changed since the last flush; `[]` when only the sheet list changed. */
  constructor(private readonly flush: (sheets: string[]) => void, private readonly quietMs = CHANGE_QUIET_MS) {}

  /** A change: its sheets join the batch and the quiet time starts again. `[]` = the sheet list changed. */
  add(sheets: string[]): void {
    for (const name of sheets) if (name) this.sheets.add(name);
    if (this.timer !== null) clearTimeout(this.timer);
    this.timer = setTimeout(() => this.fire(), this.quietMs);
  }

  dispose(): void {
    if (this.timer !== null) clearTimeout(this.timer);
    this.timer = null;
    this.sheets.clear();
  }

  private fire(): void {
    this.timer = null;
    const sheets = [...this.sheets];
    this.sheets.clear();
    this.flush(sheets);
  }
}
